import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./components/Header";
import MobileNav from "./components/MobileNav";
import Footer from "./components/Footer";
import { Container, Box, useTheme, useMediaQuery } from "@mui/material";
import Background from "./assets/images/ZHP_Background.png";
import StickyHeader from "./components/StickyHeader";

export default function Layout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showStickyHeader, setShowStickyHeader] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setShowStickyHeader(offset > 150);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundImage: `url(${Background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <StickyHeader visible={!isMobile && showStickyHeader} />
      {isMobile ? <MobileNav /> : <Header />}
      <Container sx={{ flex: 1, py: 2 }}>
        <Outlet />
      </Container>
      <Footer />
    </Box>
  );
}
